export default __webpack_public_path__ + "static/media/157-republic-of-the-congo.b0d7b2fd.svg";